import { render } from "./NavigationTitle.vue?vue&type=template&id=41cf0761&scoped=true&ts=true"
import script from "./NavigationTitle.vue?vue&type=script&lang=ts"
export * from "./NavigationTitle.vue?vue&type=script&lang=ts"

import "./NavigationTitle.vue?vue&type=style&index=0&id=41cf0761&scoped=true&lang=scss"

import exportComponent from "/Users/leonardomarsigli/code/LeoMarseo/personal-projects/dirtysocks-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cf0761"]])

export default __exports__